var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconHamburgerMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "16px",
    viewBox: "0 0 18 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 16") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Home---Mobile",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "square"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Flueid-Pro-4-Website-Public-Mobile-Home",
    transform: "translate(-360, -88)",
    stroke: "#000000"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-15",
    transform: "translate(348, 76)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-16",
    transform: "translate(13, 12.5)",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("line", {
    x1: 1.22124533e-15,
    y1: 0.5,
    x2: 16,
    y2: 0.5,
    id: "Line-2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -1.70304592e-16,
    y1: 14.5,
    x2: 16,
    y2: 14.5,
    id: "Line-2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -1.70304592e-16,
    y1: 7.5,
    x2: 10,
    y2: 7.5,
    id: "Line-2"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHamburgerMenu);
export default __webpack_public_path__ + "static/media/icon_Hamburger_Menu.c0f8b6854e6fdbb35d490b4d64f01a3c.svg";
export { ForwardRef as ReactComponent };